
export const SET_NAVIGATION_STEPS = "SET_NAVIGATION_STEPS"
export const LOADING_NAVIGATION_STEPS = "LOADING_NAVIGATION_STEPS"
export const SET_ERROR_NAVIGATION_STEPS = "SET_ERROR_NAVIGATION_STEPS"
export const SET_CURRENT_NAVIGATION_STEPS = "SET_CURRENT_NAVIGATION_STEPS"
export const SET_CURRENT_STEP = "SET_CURRENT_STEP"
export const SET_VALIDATE_FIELDS = "SET_VALIDATE_FIELDS"
export const SET_IS_VALID_FIELDS = "SET_IS_VALID_FIELDS"